module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.team), function(teamMember, index) {
    return _c('div', {
      key: index,
      staticClass: "teamMember"
    }, [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: ("url(" + (_vm.photo(teamMember.photo)) + ")")
      })
    }), _vm._v(" "), _c('div', [_c('header', [_c('h3', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(teamMember.name)
      }
    })]), _vm._v(" "), _c('h4', {
      domProps: {
        "innerHTML": _vm._s(teamMember.role)
      }
    })]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(teamMember.bio)
      }
    })])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "circleHeader"
  }, [_c('h2', [_vm._v("The Team")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d68085f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/TheTeam.vue
// module id = 802
// module chunks = 1